export enum ETacticMetricControlState {
  UNTOUCHED = 'UNTOUCHED',
  ADD = 'ADD',
  EDIT = 'EDIT',
  REMOVE = 'REMOVE',
}
